export default {
  themes: {
    light: {
      background: '#f6f8f9',
      surface: '#fff',
      primary: "#0039ec",
      secondary: "#4caf50",
      tertiary: "#495057",
      accent: "#82B1FF",
      error: "#f55a4e",
      info: "#f6f8f9",
      success: "#4aad1c",
      warning: "#ffe686",
    },
    dark: {
      background: '#040d19',
      surface: '#071426',
      primary: '#0039ec',
      'primary-darken-1': '#76b679',
      secondary: '#03DAC6',
      'secondary-darken-1': '#018786',
      error: '#B00020',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FB8C00',
    },
  },
};
